import { render, staticRenderFns } from "./BrbListWrapper.vue?vue&type=template&id=18a1d147&"
import script from "./BrbListWrapper.vue?vue&type=script&lang=js&"
export * from "./BrbListWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a1d147')) {
      api.createRecord('18a1d147', component.options)
    } else {
      api.reload('18a1d147', component.options)
    }
    module.hot.accept("./BrbListWrapper.vue?vue&type=template&id=18a1d147&", function () {
      api.rerender('18a1d147', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbListWrapper.vue"
export default component.exports